import { useState, } from 'react';
import { Popup } from 'devextreme-react/popup';
import { Button } from 'devextreme-react/button';

interface BarcodePreviewModalProps {
  visible: boolean;
  onClose: () => void;
  zplCode: string;
  labelName: string;
}

export const BarcodePreviewModal = ({ visible, onClose, zplCode, labelName }: BarcodePreviewModalProps) => {

  const [previewMethod, setPreviewMethod] = useState<'labelary' | 'canvas' | 'basic'>('labelary');
  const [isLoading, setIsLoading] = useState(false);
  const [previewError, setPreviewError] = useState<string | null>(null);

  const processZplCode = (zpl: string) => {
    if (!zpl) return 'No hay código ZPL disponible';

    let processedZpl = zpl
      // Reemplazos específicos del ejemplo
      .replace(/\[Pc_nombre\]/g, 'USUARIO DE')
      .replace(/\[Pc_apellido1\]/g, 'PRUEBA')
      .replace(/\[Pc_apellido2\]/g, '')
      .replace(/\[Pc_identificacion\]/g, '1010')
      .replace(/\[Edad\]/g, '35 A')
      .replace(/\[Gn_Nombre\]/g, 'Masculino')
      .replace(/\[Estudios\]/g, 'CRE, GLU, TRI')
      .replace(/\[Ord_numero\]/g, '25070001')
      .replace(/\[Se_Nombre\]/g, 'CONSULTA EXTERNA')
      .replace(/\[Ord_FechaCreacion\]/g, '14/07/2025 4:49:03?p.m.')
      .replace(/\[Cb_Nombre\]/g, labelName);

    return processedZpl;
  };

  // Método 1: Usando Labelary API (Recomendado)
  const renderLabelaryPreview = () => {
    const processedZpl = processZplCode(zplCode);
    const encodedZpl = encodeURIComponent(processedZpl);
    
    return (
      <div style={{ textAlign: 'center' }}>       
        <div style={{ 
          border: '2px solid #95bdf1ff',
          borderRadius: '8px',
          padding: '10px',
          backgroundColor: '#f8fcffff',
          display: 'inline-block'
        }}>
          <img 
            src={`https://api.labelary.com/v1/printers/8dpmm/labels/1.9685x0.984252/0/${encodedZpl}`}
            alt="Preview de etiqueta ZPL"
            style={{
              width: '420px',
              height: 'auto',
              border: '1px solid #ddd',
              backgroundColor: 'white'
            }}
            onLoad={() => setIsLoading(false)}
            onError={() => {
              setPreviewError('Error cargando preview desde Labelary API');
              setIsLoading(false);
            }}
          />
        </div>
        
        <div style={{ marginTop: '10px', fontSize: '11px', color: '#666' }}>
          Powered by Labelary.com API
        </div>
      </div>
    );
  };


  const renderPreview = () => {
    if (!zplCode || !zplCode.trim()) {
      return (
        <div style={{ textAlign: 'center', padding: '40px', color: '#666' }}>
          <div style={{ fontSize: '24px', marginBottom: '10px' }}>📄</div>
          <div>No hay código ZPL disponible</div>
        </div>
      );
    }

    if (isLoading) {
      return (
        <div style={{ textAlign: 'center', padding: '40px' }}>
          <div style={{ fontSize: '24px', marginBottom: '10px' }}></div>
          <div>Cargando preview...</div>
        </div>
      );
    }

    if (previewError) {
      return (
        <div style={{ textAlign: 'center', padding: '40px', color: '#d32f2f' }}>
          <div style={{ fontSize: '24px', marginBottom: '10px' }}>❌</div>
          <div>{previewError}</div>
          <Button 
            text="Reintentar" 
            onClick={() => {
              setPreviewError(null);
              setIsLoading(true);
            }} 
            style={{ marginTop: '10px' }}
          />
        </div>
      );
    }

    switch (previewMethod) {
      case 'labelary':
        return renderLabelaryPreview();
      default:
        return renderLabelaryPreview();
    }
  };


  return (
    <Popup 
      visible={visible} 
      onHiding={onClose} 
      title={`Preview ZPL - ${labelName}`} 
      width={900} 
      height='auto'
      showTitle={true} 
      showCloseButton={true}
    >
      <div style={{ padding: '10px' }}>
        {/* Preview de la etiqueta */}
        <div style={{ marginBottom: '20px' }}>
          {renderPreview()}
        </div>        
      </div>
    </Popup>
  );
};